module.exports = __webpack_public_path__ + "img/Bb1-03-028.424a1dc1.jpg";